var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"currentRowTable",staticStyle:{"width":"100%","border":"none"},attrs:{"highlight-row":"","columns":_vm.columns3,"data":_vm.data1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }